import React, { useEffect } from "react";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";

const PdfLink = ({ href, src, alt }) => (
  <div className="margin-bottom-1"> 
    <a href={href} target="_blank" rel="noreferrer">
      <img src={src} className="img-fluid" alt={alt} />
    </a>
  </div>
);
const Acuerdos2022 = () => {
  useEffect(() => {
    document.title = `Acuerdos Poder Judicial 2025`;
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Acuerdos Demarcaciones", url: "/AcuerdosPJ" },
          { label: "Acuerdos Poder Judicial 2025" },
        ]}
      />
      <TitlePages title="Acuerdos Poder Judicial 2025" subTitle="" />

      <div className="w-100 Grid__folder">
        <PdfLink
          href="https://itetlax.org.mx/assets/pdf/demarcaciones/acuerdos/INE-CG220-2025.pdf"
          src="https://itetlax.org.mx/assets/img/imgDemA/INE-CG220-2025.png"
          alt="INE CG612 2022"
        />
      </div>
    </>
  );
};

export default Acuerdos2022;
